// extracted by mini-css-extract-plugin
export default {"grid":"grid__VepPageContent__lsNIs","speciesSelectorGrid":"speciesSelectorGrid__VepPageContent__lsNIs"};